import { Pipe, PipeTransform } from '@angular/core';
import { Performer } from '../../../../globals/store/performers.data';
import { EntityRequest } from 'globals/store/programs.data';
import { getValidSortedStagingRequests } from '../../store/share.brief.functions';

@Pipe({
    name: 'validSortedStagingRequests',
    standalone: true
})
export class StagingRequestsPipe implements PipeTransform {
  transform(stagingRequests: EntityRequest[], performers: { [id:string]: Performer }) {
    return getValidSortedStagingRequests(stagingRequests, performers)
  }
}